import React, { useState, createContext, useContext } from 'react';
import { translations, Language } from '../utils/translations';
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: typeof translations.es;
  hasSelectedLanguage: boolean;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  // Lazy initializer: reads localStorage synchronously on first render
  // This prevents the flash where loader briefly appears then disappears
  const [hasSelectedLanguage, setHasSelectedLanguage] = useState<boolean>(() => {
    try {
      return !!localStorage.getItem('languageSelected');
    } catch {
      return false;
    }
  });
  const [language, setLanguageState] = useState<Language>(() => {
    try {
      const savedLang = localStorage.getItem('language') as Language;
      return savedLang || 'es';
    } catch {
      return 'es';
    }
  });
  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    setHasSelectedLanguage(true);
    try {
      localStorage.setItem('language', lang);
      localStorage.setItem('languageSelected', 'true');
    } catch {}
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t: translations[language],
    hasSelectedLanguage
  }} data-id="element-196">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}